<template>
  <div class="acc-notif-item margin-top-m">
    <div class="large margin-bottom-xs">Orders</div>
    <p class="margin-bottom-s">
      {{ orderNotif.message }}
    </p>
    <div v-if="orderNotif.notificationCode !== 524" class="margin-bottom-m">
      <NotificationsButton :page-url="'/purchases/online?linklocation=pagecontent'" :button-label="'view details button'">
        {{ INBOX.viewButtonLabel }}
      </NotificationsButton>
    </div>
  </div>
</template>
<script setup>
import { INBOX } from 'config';
import NotificationsButton from './NotificationsButton';

defineProps({
  orderNotif: {
    type: Object,
    default: () => ({}),
  },
});
</script>
